// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__+j+jH","rotate":"style_rotate__dvOYG"};